module.exports = __webpack_public_path__ + "img/二十二冶金.071fee93.png";